import React, { useState } from 'react';
import Datatable3 from '../../table/datatable3';
import { Input } from "../../ui/input";
import { ListFilter, Search } from "lucide-react";

const InvestorList = ({ getAllInvestor,totalPage,currentPage,setCurrentPage,buttonOptions, investorDetails, user_type = "investor", isEmployeeLoggedIn = false }) => {
  // State to hold the search input
  const [searchTerm, setSearchTerm] = useState('');

  // Columns definition for the table
  const columns = [
    { id: 'name', header: 'Name' },
    { id: 'user_email', header: 'Email' },
    { id: 'mobile_number', header: 'Phone No' },
    // { id: 'scheme', header: 'Scheme' },
    // { id: 'class', header: 'Class' },
  ];

  // Filter the investor details based on the search term
  const filteredData = investorDetails.filter((investor) =>
    columns.some((col) => 
      investor[col.id]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <>
       
      {/* Table Component */}
      <Datatable3
      getAllInvestor={getAllInvestor}
      totalPage={totalPage}
       currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        buttonOptions={buttonOptions}
        data={filteredData} // Pass filtered data to the table
        columns={columns}
        user_type={user_type}
        isEmployeeLoggedIn={isEmployeeLoggedIn}
      />

    </>
  );
}

export default InvestorList;
